import { useState, useEffect } from 'react';

interface CookieConsent {
  analytics: boolean;
  marketing: boolean;
  hasConsent: boolean;
}

export function useCookieConsent(): CookieConsent {
  const [consent, setConsent] = useState<CookieConsent>({
    analytics: false,
    marketing: false,
    hasConsent: false,
  });

  const syncConsent = () => {
    const storedConsent = localStorage.getItem('cookie-consent');
    if (storedConsent === 'accepted') {
      setConsent({
        analytics: true,
        marketing: true,
        hasConsent: true,
      });
      return;
    }

    if (storedConsent === 'rejected') {
      setConsent({
        analytics: false,
        marketing: false,
        hasConsent: true,
      });
      return;
    }

    setConsent({
      analytics: false,
      marketing: false,
      hasConsent: false,
    });
  };

  useEffect(() => {
    syncConsent();
  }, []);

  // Listen for changes in localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      syncConsent();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('cookie-consent-change', handleStorageChange);
    
    // Also check on visibility change (when user returns to tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleStorageChange();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cookie-consent-change', handleStorageChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return consent;
}
